import {Component, OnInit, Input, Output, EventEmitter, OnChanges} from '@angular/core';
import {Pagination} from '../../models/pagination/pagination';
import {TemplateHelper} from '../../helpers/core/template.helper';

@Component({
  selector: 'app-pagination-new',
  templateUrl: './pagination.component.html',
})
export class PaginationComponent implements OnInit, OnChanges {

  @Input() public paginationData: Pagination;
  @Output() public childEvent = new EventEmitter();
  @Output() public page = new EventEmitter();
  public childPagination;

  constructor(private templateHelper: TemplateHelper) {
  }

  ngOnInit() {
    this.initPagination();
    this.childPagination = this.templateHelper.Pagination(this.paginationData.current_page, this.paginationData.last_page);
  }

  ngOnChanges() {
    this.updatePagination();
  }

  public loadData(event) {
    const url = this.templateHelper.UrlObject(event);
    this.page.emit(url.searchParams.get('page'));
    this.childEvent.emit(event);
  }

  private updatePagination() {
    this.childPagination = this.templateHelper.Pagination(this.paginationData.current_page, this.paginationData.last_page);
  }

  private initPagination() {
    this.paginationData = {
      current_page: 0,
      first_page_url: '',
      from: 0,
      last_page: 0,
      last_page_url: '',
      next_page_url: '',
      path: '',
      per_page: 0,
      prev_page_url: '',
      to: 0,
      total: 0
    };
  }
}
